   /*=========== Sticky Header ===========*/

    function stickyHeader() {
      $(window).on('scroll', function () {
        console.log("code added")
        var sticky_menu = $('sticky-header');
        var pos = sticky_menu.position();
        if (sticky_menu.length) {
          var windowpos = sticky_menu.top;
          $(window).on('scroll', function () {
            var windowpos = $(window).scrollTop();
            if (windowpos > pos.top + 250) {
              sticky_menu.addClass('is-sticky');
            } else {
              sticky_menu.removeClass('is-sticky');
            }
          });
        }
      });
    }

    stickyHeader();

  /*=========== Mobile Menu ===========*/


  document.addEventListener("DOMContentLoaded", function () {
    // Toggle main mobile menu
    var toggleButton = document.querySelector(".meanmenu-reveal");
    var mobileNav = document.querySelector(".mobilemenu__nav");

    if (toggleButton && mobileNav) {
      toggleButton.addEventListener("click", function (e) {
        e.preventDefault();
        mobileNav.classList.toggle("active");
        toggleButton.classList.toggle("open");
      });
    }

    // Toggle submenus on clicking the + icon
    document.querySelectorAll(".submenu-toggle").forEach(function (toggle) {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();

        const parentLi = this.closest("li");
        const submenu = parentLi.querySelector("ul");

        if (submenu) {
          submenu.classList.toggle("open");

          // Toggle + to -
          if (submenu.classList.contains("open")) {
            this.textContent = "–";
          } else {
            this.textContent = "+";
          }
        }
      });
    });
  });

